import { AuthService } from './../../shared/route-guards/services/auth.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ScriptLoaderService } from 'src/app/script-loader.service';
declare var $;
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, AfterViewInit {



  constructor(private loaderService: ScriptLoaderService, private authService: AuthService) { }
  role = '';
  ngOnInit() {
    this.role = this.authService.role
  }
  ngAfterViewInit() {
    this.loaderService.loadScripts('body', [
      'assets/js/sidebarmenu.js',
      'assets/js/custom.min.js',
    ])

  }


}
